/*
 * @Date: 2022-07-04 11:43:36
 * @LastEditors: lizixuan 240514049@qq.com
 * @LastEditTime: 2022-08-01 16:01:05
 * @FilePath: \hw_game_mp_gamebrain_data\frontend\src\api\v1\group_api.js
 * @Description: 
 */
import api from "../api";

const api_type = 'v1'

export const GetGroupPage = params => { return api.post(api_type+`/user_group/page`, params) }
export const GetGroupList = params => { return api.post(api_type+`/user_group/list`, params) }
export const GetGroupInfo = params => { return api.post(api_type+`/user_group/info`, params) }
export const GroupSave = params => { return api.post(api_type+`/user_group/save`, params) }
export const GroupAuth = params => { return api.post(api_type+`/user_group/auth`, params) }
export const GetGroupTree = params => { return api.post(api_type+`/user_group/tree`, params) }

export const RelationSave = params => { return api.post(api_type+`/relation/save`, params) }
export const GetRelationPage = params => { return api.post(api_type+`/relation/page`, params) }
export const GetRelationList = params => { return api.post(api_type+`/relation/list`, params) }




// WEBPACK FOOTER //
// ./src/api/v1/group_api.js